/** Shared text parsing used by client rendering and server-side indexing. */
/** A backslash in front (`\@name`, `\#topic`) escapes them, like Discord; raw `<@id>` isn't a mention either. */
export const MENTION_RE = /(^|[^\w@\\<])@([a-zA-Z0-9_]{2,24})\b/g;
export const HASHTAG_RE = /(^|[^\w#&\\])#([a-zA-Z][a-zA-Z0-9_]{1,39})\b/g;
/** `+slug` links a post to a community. */
export const COMMUNITY_LINK_RE = /(^|[^\w+])\+([a-z0-9][a-z0-9-]{1,30}[a-z0-9])\b/g;

export function extractMentions(text: string): string[] {
  const out = new Set<string>();
  for (const m of text.matchAll(MENTION_RE)) out.add(m[2].toLowerCase());
  return [...out].slice(0, 20);
}

export function extractHashtags(text: string): string[] {
  const out = new Set<string>();
  for (const m of text.matchAll(HASHTAG_RE)) out.add(m[2].toLowerCase());
  return [...out].slice(0, 10);
}

export function extractCommunityLinks(text: string): string[] {
  const out = new Set<string>();
  for (const m of text.matchAll(COMMUNITY_LINK_RE)) out.add(m[2].toLowerCase());
  return [...out].slice(0, 5);
}

export const REACTION_EMOJIS = [
  "\u{1F44D}", "\u{1F44E}", "❤️", "\u{1F602}", "\u{1F62E}", "\u{1F622}", "\u{1F525}", "\u{1F389}",
  "\u{1F440}", "\u{1F64F}", "\u{1F4AF}", "✅", "❌", "\u{1F680}", "\u{1F914}", "\u{1F44F}",
  "\u{1F60D}", "\u{1F605}", "\u{1F64C}", "\u{1F480}", "⭐", "\u{1F91D}", "\u{1F60E}", "\u{1F4CC}",
] as const;

export const REACTION_SET: ReadonlySet<string> = new Set(REACTION_EMOJIS);
